var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMisc = function SvgMisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.639 10.237a1.501 1.501 0 0 1-.877-.876l-2.761-7.36h-17.5A1.5 1.5 0 0 0 5 3.5v37A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.502V13l-7.361-2.762Z",
    fill: "#343842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fillOpacity: 0.35,
    fill: "#343842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 29v2.5c0 .275.225.5.5.5h11c.275 0 .5-.225.5-.5V29h1v2.5c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5V29h1Zm6.5-10v8.617l2.79-2.798.71.707-4 4.01-3.999-4.01.707-.707 2.792 2.8V19h1Z",
    fill: "#FFF"
  }))));
};
export default SvgMisc;